export function formatItalianDate(inputDate) {
  if (!inputDate || inputDate === "0001-01-01T00:00:00") return "N/A";
  const dateObj = new Date(inputDate);

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = dateObj.getFullYear();

  return `${day}-${month}-${year}`;
}

export function convertToDMY(date) {
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
}

export function formatDDMmmYYYYHHMM(dateIsoFormat) {
  const data = new Date(dateIsoFormat);

  const giorno = String(data.getDate()).padStart(2, "0");
  const mese = data.toLocaleDateString("it-IT", { month: "short" });
  const anno = data.getFullYear();
  const ora = String(data.getHours()).padStart(2, "0");
  const minuti = String(data.getMinutes()).padStart(2, "0");

  return `${giorno} ${mese} ${anno} · ${ora}:${minuti}`;
}

export function extractYYYYMMDDFromISO(isoDate) {
  if (isoDate === undefined || isoDate === null) {
    return undefined;
  }
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function generateLast10Years() {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let i = currentYear; i > currentYear - 10; i--) {
    years.push({ label: `${i}`, value: i });
  }

  return years;
}

export function toISOString(inputDate) {
  if (inputDate === undefined) return undefined;
  const date = new Date(inputDate);
  const formattedDate = date.toISOString();
  return formattedDate;
}

export function generateAnniDiRiferimento(
  startYear,
  endYear,
  insertGenericLabel
) {
  const objectsArray = [];
  for (let year = startYear; year <= endYear; year++) {
    objectsArray.push({
      label:
        new Date().getFullYear() === year
          ? `Anno Corrente (spese fiscali ${year - 1})`
          : `${year} (spese fiscali ${year - 1})`,
      value: year,
    });
  }
  insertGenericLabel &&
    objectsArray.unshift({ label: "GENERICO", value: "GENERICO" });
  return objectsArray;
}

export const convertiDataISO = (dataString) => {
  // Dividi la stringa della data in giorno, mese e anno
  var partiData = dataString.split("/");

  // Costruisci la data usando l'anno, il mese (sottraendo 1 poiché i mesi in JavaScript iniziano da 0) e il giorno
  var data = new Date(partiData[2], partiData[1] - 1, partiData[0]);

  // Ritorna la data in formato ISO
  return data.toISOString();
};

export function formattaDataOra(dataBackend) {
  const data = new Date(dataBackend);

  // Formattare la data e ora
  const giorno = String(data.getDate()).padStart(2, "0");
  const mese = String(data.getMonth() + 1).padStart(2, "0");
  const anno = data.getFullYear();
  const ora = String(data.getHours()).padStart(2, "0");
  const minuti = String(data.getMinutes()).padStart(2, "0");

  // Creare la stringa formattata
  const stringaData = `DATA: ${giorno}/${mese}/${anno} - ORA: ${ora}:${minuti}`;

  return stringaData;
}

export function formattaDataOraIta(dataBackend) {
  const data = new Date(dataBackend);

  // Formattare la data e ora
  const giorno = String(data.getDate()).padStart(2, "0");
  const mese = String(data.getMonth() + 1).padStart(2, "0");
  const anno = data.getFullYear();

  // Calcolare l'offset del fuso orario in minuti
  const offset = -data.getTimezoneOffset(); // Offset in minuti
  const oreOffset = Math.floor(Math.abs(offset) / 60);
  const minutiOffset = Math.abs(offset) % 60;

  // Sommare l'offset all'ora attuale
  let ora = data.getHours() + oreOffset;
  let minuti = data.getMinutes() + minutiOffset;

  // Creare la stringa formattata finale
  const stringaData = `${giorno}/${mese}/${anno} - ${String(ora).padStart(
    2,
    "0"
  )}:${String(minuti).padStart(2, "0")}`;

  return stringaData;
}

export function formattaData(dataBackend) {
  if (!dataBackend) return "N/A";
  const data = new Date(dataBackend);

  // Formattare la data e ora
  const giorno = String(data.getDate()).padStart(2, "0");
  const mese = String(data.getMonth() + 1).padStart(2, "0");
  const anno = data.getFullYear();

  // Creare la stringa formattata
  const stringaData = `${giorno}/${mese}/${anno}`;

  return stringaData;
}

export const formatTimeRange = (oraInizio, oraFine) => {
  const formatTime = (time) => {
    if (!time || typeof time !== "string" || time.length < 4) return "N/A";
    return `${time.slice(0, 2)}:${time.slice(2)}`;
  };
  return `${formatTime(oraInizio)} / ${formatTime(oraFine)}`;
};

export function formattaDataCompatta(dataCompatta) {
  if (!dataCompatta || dataCompatta.length !== 8) return "N/A";

  const anno = dataCompatta.slice(0, 4);
  const mese = dataCompatta.slice(4, 6);
  const giorno = dataCompatta.slice(6, 8);

  return `${giorno}/${mese}/${anno}`;
}
